import React from "react";
import DailySummaryTable from "../../components/Report/DailySummaryTable";

const ReportDailySummaryPage: React.FC = () => <DailySummaryTable />;
export default ReportDailySummaryPage;
